module.exports = __webpack_public_path__ + "static/img/nodata.de734042.png";